<template lang="pug">
    .article_container
        template(v-if="article")
            .article_inner
                .article_header
                    .article_header_categories
                        span.article_category {{ article.category.screen_name }}
                        .article_sub_category(v-if="showSubCategory")
                            span.article_sub_category_item._label(:style="{ color: article.sub_category.color.text, 'background-color': article.sub_category.color.background }" style="pointer-events: none;") {{ article.sub_category.screen_name }}
                    .article_header_data(v-if="showDate")
                        span.article_date(v-if="showDate") {{ formattedDate(article.published_at) }}
                h1.article_h1(:class="addLarge") {{ article.title }}
                component(is="style")  {{ article.css }}
                .article_body(v-html="article.content")
                .article_tag
                    ul.article_tag_list(v-if="article.tags.length > 0")
                        li.article_tag_item(v-for="(tag, index) in article.tags")
                            a(href="#" style="pointer-events: none;") {{ tag }}
            .article_footer
                .inner
                    public-related-article-card-list(:relatedArticleList="article.related_articles")
                    .article_return
                        .button._arrow._prev(style="pointer-events: none;")
                            span 一覧ページへ
        template(v-else)
            .article_inner
                p.preview_invalid
                    | このURLは無効です。
                    br
                    | 「プレビュー」ボタンを押して、開き直してください。
</template>

<script>
import PublicRelatedArticleCardList from '@/components/PublicRelatedArticleCardList.vue'

// highlight.js
import hljs from 'highlight.js/lib/core'
import html from 'highlight.js/lib/languages/xml'
import css from 'highlight.js/lib/languages/css'
import scss from 'highlight.js/lib/languages/scss'
import javascript from 'highlight.js/lib/languages/javascript'
import scala from 'highlight.js/lib/languages/scala'
import ruby from 'highlight.js/lib/languages/ruby'
import php from 'highlight.js/lib/languages/php'
import sql from 'highlight.js/lib/languages/sql'
import bash from 'highlight.js/lib/languages/bash'
import shell from 'highlight.js/lib/languages/shell'

hljs.registerLanguage('html', html)
hljs.registerLanguage('css', css)
hljs.registerLanguage('scss', scss)
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('scala', scala)
hljs.registerLanguage('ruby', ruby)
hljs.registerLanguage('php', php)
hljs.registerLanguage('sql', sql)
hljs.registerLanguage('bash', bash)
hljs.registerLanguage('shell', shell)

export default {
    name: 'Preview',
    head: {
    title() {
      return {
        inner: 'プレビュー',
        separator: '|',
        complement: '管理画面',
      }
    }
  },
    components: {
        PublicRelatedArticleCardList
    },
    data(){
        return {
            article: null,
            content: null
        }
    },
    created() {
        this.article = JSON.parse( localStorage.getItem('post-' + this.$route.query.id) )

        let _content = this.article.category.value
        this.$store.dispatch('setContent', _content)
        this.content = this.$store.state.content
    },
    mounted() {
        this.$nextTick(function(){
            hljs.initHighlighting()
            hljs.initHighlighting.called = false
        })
    },
    computed: {
        showSubCategory() {
            return this.article.sub_category
        },
        showDate() {
            return ['news', 'articles'].includes(this.content)
        },
        addLarge() {
            return { '_large': ['service', 'company'].includes(this.content) }
        },
        formattedDate() {
            return function (date) {
                if(date){
                    date = date.slice(0, 10).replace(/\//g, '.').replace(/-/g, '.')
                    return date
                }
            }
        }
    },
}
</script>

<style lang="sass">
/*
    プレビュー画面表示のため、公開画面のcssを貼り付ける。
    .article_body内の変更があった場合には、postEditos.cssにも変更を反映させること。
    */

/*------カラー指定----------------------*/
$primary-color: #4E93A6
$dark-color: #004471

$black: #333333
$white: #fff
$light-gray: #F8F9F9
$light-gray2: #ECECEC
$gray: #ccc
$gray2: #ddd

$red: #F14568
$color-highlight: #fff990
$color-inlinecode: #F6F6F7

$font-jp_primary: 'Noto Sans JP','Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', 'メイリオ', 'Meiryo', 'verdana', sans-serif
$font-brandon: brandon-grotesque, sans-serif
$font-futura: futura-pt, sans-serif

@mixin mq($breakpoint: minimum)
    @if $breakpoint == minimum
        @media screen and (max-width: 560px)
            @content
    @else if $breakpoint == medium
        @media screen and (max-width: 960px)
            @content
    @else if $breakpoint == large
        @media screen and (min-width: 961px)
            @content


/* ----------------------------------------
/* _layout.sass
/* ----------------------------------------
.inner
    max-width: 1148px
    margin: 0 auto
    padding: 0 24px
    @include mq(medium)
        max-width: 100%
    @include mq()
        padding: 0 16px

.site_container
    display: flex
    flex-direction: column
    min-height: 100vh
    &::before
        display: none
        position: fixed
        top: 0
        left: 0
        content: ''
        width: 100vw
        height: 100%
        background: rgba($white, .9)
        transition: all 200ms

.content_container
    padding-top: 110px
    padding-bottom: 40px
    @include mq()
        padding-top: 84px

.article_container
    width: 100%
    padding: 110px 0 90px
    @include mq()
        padding: 88px 0 40px

.article_inner
    width: 680px
    margin: 0 auto
    @include mq(medium)
        width: 92%


/* ----------------------------------------
/* _animation.sass
/* ----------------------------------------
/* ヘッダー：ロゴのアニメーション */
@keyframes stroke_primary
    0%
        stroke-dashoffset: 1425px
        fill: #fff
    15%
        fill: $primary-color
    25%
        fill: $primary-color
    30%
        stroke-dashoffset: 0
        fill: $primary-color
    50%
        stroke-dashoffset: 0
        fill: $primary-color
    100%
        stroke-dashoffset: 0
        fill: $primary-color

@keyframes stroke_dark
    0%
        stroke-dashoffset: 1425px
        fill: #fff
    15%
        fill: $dark-color
    25%
        fill: $dark-color
    30%
        stroke-dashoffset: 0
        fill: $dark-color
    50%
        stroke-dashoffset: 0
        fill: $dark-color
    100%
        stroke-dashoffset: 0
        fill: $dark-color



/* ヘッダー：ナビゲーションのアニメーション */
@keyframes easein_bg
    0%
        background: transparent
        color: transparent
    100%
        background: $primary-color
        color: $white

@keyframes easein_bg-light
    0%
        background: transparent
        color: transparent
    100%
        background: rgba($primary-color, .6)
        color: $white

@keyframes text_stand_up
    0%
        padding-top: 1.4em
    100%
        padding-top: 0

@keyframes text_stand_up_sp
    0%
        padding-top: 3.8em
    100%
        padding-top: 0

@keyframes fadein
    0%
        opacity: 0
    100%
        opacity: 1

@keyframes scroll-border
    0%
        transform: translate3d(0,0,0)
    100%
        transform: translate3d(0,200%,0)

@keyframes fadein_up
    0%
        opacity: 0
        transform: translateY(100px)
    100%
        opacity: 1
        transform: translateY(0px)

/* ----------------------------------------
/* style.sass TOPと記事一覧以外
/* ----------------------------------------
html
    font-size: 62.5%
    word-wrap: break-word
body
    font-family: $font-jp_primary
    font-size: 1.6rem
    line-height: 1.6
    color: $black

*,
*::before,
*::after
    box-sizing: border-box

button, select
    background-color: transparent
    border: none
    cursor: pointer
    padding: 0
    appearance: none

.sp_disp
    display: none
    @include mq()
        display: block


#logo
    margin-bottom: 2px
    width: 186px
    stroke: #4e92a6
    stroke-width: 1px
    fill: transparent
    stroke-dasharray: 1425px
    stroke-dashoffset: 1425px
    .st0
        fill: $primary-color
        // animation: stroke_primary 10s ease-in 0s forwards
        // animation-iteration-count: infinite
    .st1
        fill: $dark-color
        // animation: stroke_dark 10s ease-in 0s forwards
        // animation-iteration-count: infinite

#toast
    position: fixed
    display: flex
    flex-direction: column
    top: 0
    right: 0
    bottom: 0
    left: 0
    z-index: 999
    pointer-events: none
    .alert
        display: inline-flex
        align-self: center
        text-align: center
        margin: 80px .5em
        padding: .75em 2em
        border-radius: 50px
        box-shadow: 0 0 10px rgba(0,0,0,0.2)
        text-align: center
        background-color: $red
        color: $white
        opacity: .9
        @include mq()
            padding: .75em 1em

/* ヘッダー：オーバーレイ */
.overlay
    display: none
    @include mq(medium)
        display: block
        position: fixed
        top: 0
        left: 0
        right: 0
        bottom: 0
        background: rgba($black, .9)
        z-index: -2
        opacity: 1

.fadein-enter-active
    transition: opacity 150ms
.fadein-enter, .fadein-leave-to
    opacity: 0

/* ボタンリンクの共通スタイル */
.button
    display: flex
    align-items: center
    justify-content: center
    position: relative
    width: 432px
    height: 84px
    padding: .2em 2em
    background: $white
    border: 1px solid $black
    border-radius: 3px
    color: $black
    font-size: 1.8rem
    font-weight: 700
    overflow: hidden
    @include mq(medium)
        height: 64px
        font-size: 1.6rem
    @include mq(minimum)
        width: 90%
    &::before
        position: absolute
        top: 0
        left: -100%
        content: ''
        display: block
        width: 100%
        height: 100%
        background-color: $primary-color
        transition: all .2s
        z-index: 0
    @media (hover: hover)
        &:hover
            cursor: pointer
            border: 1px solid $primary-color
            color: $white
            transition: all .2s
            &::before
                left: 0
    span
        display: block
        z-index: 1
    // 装飾
    &._arrow
        span
            &::before
                position: absolute
                top: calc(50% - 10px)
                content: ''
                display: block
                width: 24px
                height: 24px
                border: 2px solid $black
                border-radius: 50%
            &::after
                position: absolute
                top: calc(50% - 2px)
                content: ''
                display: block
                width: 8px
                height: 8px
                border: 2px solid transparent
                border-top: 2px solid $black
                border-right: 2px solid $black
                border-radius: 2px
    &._arrow._next
        span
            &::before
                right: 25px
            &::after
                right: 35px
                transform: rotate(45deg)
    &._arrow._prev
        &::before
            left: auto
            right: -100%
        span
            &::before
                left: 25px
            &::after
                left: 35px
                transform: rotate(-135deg)
        @media (hover: hover)
            &:hover
                &::before
                    right: 0
                > span::before
                    border-color: $white
                    transition: all .1s
                > span::after
                    border-top: 2px solid $white
                    border-right: 2px solid $white
                    transition: all .1s
    // カラー
    &._primary
        background-color: $primary-color
        border: 1px solid $primary-color
        &::before
            background-color: $dark-color
        span
            color: $white
        &._arrow
            span::before
                border-color: $white
            span::after
                border-top-color: $white
                border-right-color: $white
        @media (hover: hover)
            &:hover
                border: 1px solid $dark-color

.global_hamburger_button
    position: relative
    display: none
    width: 44px
    height: 44px
    top: .2em
    right: -8px
    transition-duration: 0.5s
    cursor: pointer
    @include mq(medium)
        display: block
    &::after
        position: absolute
        top: 30px
        right: 8px
        content: 'menu'
        display: block
        font-size: 1.1rem
        font-weight: bold
    &_left
        transition-duration: 0.5s
        position: absolute
        top: 14px
        right: 20px
        width: 15px
        height: 3px
        background-color: $black
        &::before
            transition-duration: 0.5s
            position: absolute
            right: 0
            width: 15px
            height: 3px
            background-color: $black
            content: ""
            top: -10px
        &::after
            transition-duration: 0.5s
            position: absolute
            right: 0
            width: 15px
            height: 3px
            background-color: $black
            content: ""
            top: 10px
    &_right
        transition-duration: 0.5s
        position: absolute
        top: 14px
        right: 10px
        width: 15px
        height: 3px
        background-color: $black
        &::before
            transition-duration: 0.5s
            position: absolute
            right: 0
            width: 15px
            height: 3px
            background-color: $black
            content: ""
            top: -10px
        &::after
            transition-duration: 0.5s
            position: absolute
            right: 0
            width: 15px
            height: 3px
            background-color: $black
            content: ""
            top: 10px

.hamburger_opend
    @include mq(medium)
        position: relative
        overflow: hidden
        width: 100vw
        height: 100%
        &.global_header
            background: none
            &::before
                transform: translateX(-100%)
                transition: transform 180ms ease-in
        .global_navigation_content
            transform: translateX(-100%)
            transition: transform 180ms ease-in
        .global_hamburger_button
            &::after
                content: 'close'
            &_left
                transition-duration: 500ms
                background: transparent
                &::before
                    transform: rotateZ(45deg) scaleX(1) translate(4px, 4px)
                &::after
                    transform: rotateZ(-45deg) scaleX(1) translate(4px, -4px)
            &_right
                transition-duration: 500ms
                background: transparent
                &::before
                    transform: rotateZ(-45deg) scaleX(1) translate(-4px, 4px)
                &::after
                    transform: rotateZ(45deg) scaleX(1) translate(-4px, -4px)

.global
    &_header
        position: fixed
        top: 0
        left: 0
        width: 100vw
        background: $white
        z-index: 5
        @include mq(medium)
            padding: .5em 0
        &::before
            content: ''
            display: block
            position: absolute
            top: 0
            right: -100%
            width: 100%
            height: 60px
            background: rgba($white, .8)
            transform: translateX(0)
            transition: transform 150ms ease-in
            z-index: -1
        .inner
            display: flex
            justify-content: space-between
            align-items: flex-end
    &_navigation
        &_content
            @include mq(medium)
                position: fixed
                top: 60px
                right: -100%
                width: 100%
                height: calc( 100vh - 60px )
                padding: 1em 24px 0
                background: rgba($white, .8)
                transform: translateX(0)
                transition: transform 150ms ease-in
                overflow: auto
            @include mq()
                padding: 1em 16px 0
        &_list
            display: flex
            align-items: baseline
            @include mq(medium)
                display: block
        &_item
            a
                display: flex
                align-items: flex-end
                height: 52px
                padding: 6px 12px
                border-bottom-left-radius: 3px
                border-bottom-right-radius: 3px
                font-size: 1.5rem
                font-weight: bold
                letter-spacing: 1px
                @include mq(medium)
                    display: flex
                    align-items: center
                    padding: 6px 0
                    font-size: 2.2rem
                @media (hover: hover)
                    &:hover
                        color: transparent
                        animation: easein_bg-light 100ms ease-in 0s forwards
                        cursor: pointer
                        @include mq(medium)
                            color: $black
                            animation: none
                &.is_active
                    color: transparent
                    animation: easein_bg 120ms ease-in 0ms forwards
                    @include mq(medium)
                        color: $primary-color
                        animation: none
                span
                    display: none
                    @include mq(medium)
                        display: inline-block
                        margin-left: 1em
                        font-size: 1.6rem
                        font-weight: 400
            &:not(:last-child)
                margin-right: .8em
                @include mq(medium)
                    margin-right: 0
        &_isms
            display: none
            @include mq(medium)
                display: block
                margin-top: 16px
                margin-bottom: 16px
                img
                    width: 124px
                    height: auto
    &_footer
        opacity: .8
        display: flex
        align-items: center
        justify-content: center
        margin-top: auto
        width: 100%
        height: 24px
        font-size: 1.2rem

/* 記事カードのスタイル */
.card
    &.js_fadein
        animation: fadein_up 200ms
    &_link
        @media (hover: hover)
            &:hover .card_thumbnail_img,
            &:focus .card_thumbnail_img
                transform: scale(1.07)
                transition: transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1)
    &_thumbnail
        margin-bottom: 16px
        border: 1px solid $gray
        border-radius: 3px
        overflow: hidden
        /* Safari バグ対策 */
        position: relative
        z-index: 1
    &_thumbnail_img
        width: 100%
        padding-top: 70%
        background-size: cover
        background-position: center center
        background-repeat: no-repeat
        transition: transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1)
    &_item
        display: flex
        flex-direction: column
        padding: 0 8px
        width: 100%
        &_header
            display: flex
            justify-content: space-between
            flex-wrap: wrap
            padding-bottom: 8px
    &_categories
        display: flex
        align-items: center
    &_category
        font-size: 1.6rem
        font-family: $font-brandon
        font-weight: 700
        font-style: normal
        letter-spacing: 1px
        &._category
            margin-right: 10px
    &_date
        margin-left: auto
        font-family: $font-brandon
        font-size: 1.4rem
        letter-spacing: 1.5px
        white-space: nowrap
    &_title
        font-size: 1.6rem
        font-weight: 500
    a[target=_blank]
        .card_title::after
            content: ''
            display: inline-block
            width: 16px
            height: 16px
            background: center / contain no-repeat url('../../public/img/icon_external_link.png')
            margin: 0 5px
            vertical-align: -2px

._label
    display: inline-flex
    padding: 6px 6px 5px
    border-radius: 3px
    font-size: 1.2rem
    color: $white
    background: #999
    line-height: 1
    white-space: nowrap

/* 記事個別スタイル */
.article
    &_header
        display: flex
        flex-wrap: wrap
        align-items: baseline
        @include mq(medium)
            justify-content: space-between
    &_header_categories
        display: flex
        flex-wrap: wrap
        align-items: center
    &_category
        display: none
        margin-right: 1em
        font-family: $font-brandon
        font-weight: 700
        font-size: 1.6rem
        letter-spacing: 1px
        line-height: 1
        opacity: .8
        white-space: nowrap
        /* _category, _sub_category, _date でmargin-bottom合わせる */
        margin-bottom: 20px
        @include mq(medium)
            margin-bottom: 10px
            display: block
    &_sub_category
        position: relative
        margin-right: 1em
        /* _category, _sub_category, _date でmargin-bottom合わせる */
        margin-bottom: 20px
        @include mq(medium)
            margin-bottom: 10px
    &_sub_category_item
        padding: 8px 8px 7px
        vertical-align: baseline
        color: $white
        font-size: 1.4rem
        font-family: $font-brandon
        font-weight: 700
        letter-spacing: 1px
        transition: 200ms ease
        @media (hover: hover)
            &:hover
                opacity: 0.6
        @include mq(medium)
            padding: 7px 8px 6px
    &_header_date
        @include mq(medium)
            margin-left: auto
    &_date
        display: inline-block
        margin-left: auto
        font-weight: 700
        font-family: $font-brandon
        font-size: 1.5rem
        letter-spacing: 1.5px
        opacity: .8
        white-space: nowrap
        /* _category, _sub_category, _date でmargin-bottom合わせる */
        margin-bottom: 20px
        @include mq(medium)
            margin-bottom: 10px
    &_tag
        margin-top: 4em
        &_list
            display: flex
            flex-wrap: wrap
        &_item
            margin-right: .8em
            margin-bottom: .8em
            @include mq()
                margin-bottom: 0.6em
            a
                display: block
                padding: .5em 1.3em .6em
                background: #f4f4f4
                border-radius: 50px
                font-size: 1.4rem
                line-height: 1
                transition: 200ms ease
                @include mq(medium)
                    padding: .4em 1.3em .5em
                @media (hover: hover)
                    &:hover
                        background: #ccc
    &_h1
        display: flex
        width: 100%
        font-size: 3.8rem
        letter-spacing: 1px
        font-weight: 700
        line-height: 1.4
        @include mq()
            font-size: 2.4rem
        &._large
            @include mq()
                font-size: 3.3rem
    &_footer
        margin-top: 144px
        @include mq()
            margin-top: 100px
    &_return
        display: flex
        justify-content: center
        margin-top: 8em
        @include mq()
            margin-top: 5em
    &_body // 記事内スタイルデフォルト値
        margin: 2.6em auto 0
        font-size: 1.6rem
        line-height: 1.9
        @include mq(medium)
            width: 100%
            margin-top: 2em
            line-height: 1.8
        /* heading */
        h2
            margin: 2.4em 0 .6em
            font-size: 2.7rem
            font-weight: 700
            line-height: 1.5
            @include mq()
                font-size: 2rem
        h3
            margin: 2.4em 0 .6em
            font-size: 2rem
            font-weight: 700
            line-height: 1.5
            @include mq()
                font-size: 1.8rem
        h4
            margin: 2em 0 .6em
            font-size: 1.8rem
            font-weight: 700
            @include mq()
                font-size: 1.7rem
        p // blockquote内で打ち消す
            margin: 1em 0 2.2em
        p + p
            margin-top: 2.2em
        /* image */
        img
            max-width: 100%
            height: auto
        img.fr-dib,
        img.fr-dib.fr-fic
            margin: 5px auto
            display: block
        img.fr-dib.fr-fir,
        span.fr-img-caption.fr-dib.fr-fir
            margin-right: 0px
            text-align: right
        img.fr-dib.fr-fil,
        span.fr-img-caption.fr-dib.fr-fil
            margin-left: 0px
            text-align: left
        span.fr-img-caption
            position: relative
            max-width: 100%
        span.fr-img-caption.fr-dib
            margin: 5px auto
            display: block
            float: none
            vertical-align: top
        .fr-img-caption .fr-img-wrap
            padding: 0px
            margin: auto
            text-align: center
            width: 100%
        img.fr-bordered,
        .fr-img-caption.fr-bordered img
            border: 1px solid rgba($black, .4)
        img.fr-rounded,
        .fr-img-caption.fr-rounded img
            border-radius: 10px
        img.fr-shadow,
        .fr-img-caption.fr-shadow img
            box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02)
        .fr-inner // キャプション
            display: block
            font-size: 1.4rem
        /* link */
        a
            color: $black
            text-decoration: underline
            @media (hover: hover)
                &:hover, &:focus
                    color: $primary-color
                    opacity: .6
                    transition: opacity 150ms
        a[target=_blank]::after
            content: ''
            display: inline-block
            width: 16px
            height: 16px
            background: center / contain no-repeat url('../../public/img/icon_external_link.png')
            margin: 0 5px
            vertical-align: -2px
        /* blockquote */
        blockquote
            position: relative
            margin-top: 2.2em
            margin-bottom: 2.2em
            padding: 1.8em 2.6em
            background: $light-gray
            @include mq()
                padding: 2em 1.4em
                font-size: 1.5rem
            p
                margin: 0
            p + p
                margin-top: 1.4em
        /* list */
        ol,
        ul
            padding-left: 1.5em
        ol
            list-style: decimal
        ul
            list-style: disc
        /* table */
        table
            th
                background-color: $light-gray2
            th,
            td
                padding: .6em 8px
                border: solid 1px $gray2
                p
                    margin: .2em 0
            th.fr-highlighted,
            td.fr-highlighted
                border: 1px double red
            th.fr-thick,
            td.fr-thick
                border-width: 2px
            &.fr-alternate-rows tbody tr:nth-child(2n)
                background: whitesmoke
            &.fr-border-none tbody th,
            &.fr-border-none tbody td
                border: none
        /* sub sup */
        sub
            vertical-align: sub
            font-size: smaller
        sup
            vertical-align: super
            font-size: smaller
        /* hr */
        hr
            display: block
            height: 1px
            border: 0
            border-top: 1px solid $gray
            margin: 1em 0
            padding: 0
        /* youtube */
        .fr-video
            display: block
            position: relative
            width: 100%
            padding-top: 56.25%
            iframe
                position: absolute
                top: 0
                right: 0
                width: 100%
                height: 100%
        /* iframe （Google Mapなど） */
        iframe
            max-width: 100%
        /* code - styleにはhighlight.js使用 */
        code
            font-size: 1.4rem
            padding: 20px
            @include mq()
                padding: 16px
        /* inline class */
        .fr-class-code
            padding: 1px 4px
            border-radius: 2px
            background: $color-inlinecode
            font-family: inherit
        .fr-class-highlighted
            background: linear-gradient(transparent 60%, $color-highlight 60%)
        .fr-class-transparency
            opacity: 0.5


/* 関連記事 */
.related_article
    &_title
        margin-bottom: 1em
        font-size: 1.8rem
        font-weight: normal
        ._en
            font-family: $font-brandon
            font-size: 2.7rem
            font-weight: 700
            font-style: normal
            letter-spacing: 1.5px
        ._jp
            margin-left: .8em
            letter-spacing: 1px
    &_card_list
        display: flex
        justify-content: space-between
        flex-wrap: wrap
        &::after
            content: ''
            display: block
            width: 31%
        .card
            width: 31%
            @include mq()
                width: 100%
                &:not(:first-of-type)
                    margin-top: 48px


/* エラーページ */
.error
    text-align: center
    &_title
        margin-top: 42px
        font-size: 4rem
        @include mq()
            font-size: 2rem
    &_desc
        margin-top: 40px
        @include mq()
            margin-top: 16px
    &_button
        display: flex
        justify-content: center
        margin-top: 80px
        @include mq()
            margin-top: 48px

/* 管理画面プレビュー用 */
.card // buefy打ち消し
    box-shadow: none
    color: inherit
.preview_invalid
    padding: 2em 0
    font-size: 2.4rem
    line-height: 2

/*Gruvbox style (dark) (c) Pavel Pertsev (original style at https://github.com/morhetz/gruvbox)*/
.article_body
    .hljs
        display: block
        overflow-x: auto
        background: #282828

    .hljs,
    .hljs-subst
        color: #ebdbb2

    /* Gruvbox Red */
    .hljs-deletion,
    .hljs-formula,
    .hljs-keyword,
    .hljs-link,
    .hljs-selector-tag
        color: #fb4934

    /* Gruvbox Blue */
    .hljs-built_in,
    .hljs-emphasis,
    .hljs-name,
    .hljs-quote,
    .hljs-strong,
    .hljs-title,
    .hljs-variable
        color: #83a598

    /* Gruvbox Yellow */
    .hljs-attr,
    .hljs-params,
    .hljs-template-tag,
    .hljs-type
        color: #fabd2f

    /* Gruvbox Purple */
    .hljs-builtin-name,
    .hljs-doctag,
    .hljs-literal,
    .hljs-number
        color: #8f3f71

    /* Gruvbox Orange */
    .hljs-code,
    .hljs-meta,
    .hljs-regexp,
    .hljs-selector-id,
    .hljs-template-variable
        color: #fe8019

    /* Gruvbox Green */
    .hljs-addition,
    .hljs-meta-string,
    .hljs-section,
    .hljs-selector-attr,
    .hljs-selector-class,
    .hljs-string,
    .hljs-symbol
        color: #b8bb26

    /* Gruvbox Aqua */
    .hljs-attribute,
    .hljs-bullet,
    .hljs-class,
    .hljs-function,
    .hljs-function .hljs-keyword,
    .hljs-meta-keyword,
    .hljs-selector-pseudo,
    .hljs-tag
        color: #8ec07c

    /* Gruvbox Gray */
    .hljs-comment
        color: #928374

    /* Gruvbox Purple */
    .hljs-link_label,
    .hljs-literal,
    .hljs-number
        color: #d3869b

    .hljs-comment,
    .hljs-emphasis
        font-style: italic

    .hljs-section,
    .hljs-strong,
    .hljs-tag
        font-weight: bold
</style>